import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// In-app "← Back to X" link. The previous implementation hardcoded a path
// like /admin/accounts, which lost any filters/search/pagination the user
// had applied before opening the detail page.
//
// We instead use browser history (navigate(-1)) which lands the user on
// the exact history entry they came from — including any querystring
// filters. The static `to` is used only as a fallback when there's no
// in-app history (deep-link or direct page load), detected via
// location.key === 'default' (React Router 6's marker for the very first
// history entry of a session).
export default function BackLink({ to, children, className }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handle = (e) => {
    e.preventDefault();
    if (location.key === 'default') {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <a href={to} onClick={handle} className={className}>
      {children}
    </a>
  );
}
